module.exports = __webpack_public_path__ + "static/WelcomeToElk1-25aabdf154e0c7afb57e6c826162d981.webp";